import { ReactNode } from 'react'
import { Navigate, useParams } from 'react-router'

import { createRedirectPath } from './createRedirectPath'
import { defaultRouteValidationMap } from './defaultRouteValidationMap'
import { useDirectFlowPath } from '../utils'
import { usePersistentState } from 'directFlow/state'
import { StepPage } from 'directFlow/types'

import { VehicleType } from 'types'

interface Props {
  children: ReactNode
  routeName: StepPage
  isDirect?: boolean
  startPath?: string
}

export const ValidateDirectRoutes = ({ children, routeName, isDirect, startPath }: Props) => {
  const { quoteId } = useParams<{ quoteId: string }>()
  const persistentState = usePersistentState()
  const pathUtil = useDirectFlowPath()

  const formProgress = persistentState.stateRef.current?.formProgress || []

  const fullState = persistentState.stateRef.current
  const isDirectLead = fullState?.quoteGeneralInfo.directLead
  const vehicleFoundData = fullState?.pageState?.vehicleFound
  const isVan = vehicleFoundData?.vehicleType === VehicleType.VAN

  const isQuoteCompleted = Boolean(localStorage.getItem(`quote-${quoteId}-completed`))

  const defaultRouteValidations = defaultRouteValidationMap({
    isVan,
    formProgress,
  })

  const redirectPath = createRedirectPath({
    quoteId,
    pathUtil,
    isQuoteCompleted,
    isDirectLead: Boolean(isDirectLead),
    startPath,
  })

  if (isDirect && !defaultRouteValidations[routeName as StepPage]) {
    return <Navigate replace to={redirectPath} />
  }

  return <>{children}</>
}
